<mat-form-field
  [appearance]="appearance ?? 'fill'"
  class="autocomplete-container w-100 tight-input"
  [ngClass]="{ 'mat-form-field-invalid': hasError() }"
  [ngClass]="getClass()"
  subscriptSizing="dynamic"
>
  <input
    type="search"
    matInput
    [placeholder]="placeholder"
    [(ngModel)]="inputValue"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="disabled"
    (input)="onInputChanged($event)"
    (blur)="onBlur()"
    (focus)="onFocus()"
    (search)="onCancel($event)"
    [matAutocompleteDisabled]="true"
    (click)="toggleDropdown($event)"
    [matAutocomplete]="auto"
    class="!text-[var(--mat-sys-on-surface)]"
    [ngClass]="{
      'pr-8!': inputValue,
      'pr-2!': !inputValue
    }"
  />

  <!-- loading -->
  @if (loading) {
    <div class="loading-autocomplete bg-white dark:bg-[var(--mat-card-elevated-container-color)]!">
      <mat-spinner class="spinner" diameter="20"></mat-spinner>
    </div>
  }
  @else {
    @if (inputValue) {
      <!-- clear icon -->
      <i-tabler name="x" class="icon-14 absolute right-4 top-[50%] translate-y-[-50%] cursor-pointer hover:text-[var(--mat-sys-primary)]" (click)="clearInput($event)" />
    }
  
    <!-- arrow icon -->
    <div (click)="toggleDropdown($event)" class="mat-mdc-select-arrow icon-16 absolute! right-[-4px] top-[50%] translate-y-[-50%] cursor-pointer hover:text-[var(--mat-sys-primary)]" [ngClass]="{ 'arrow-open': isOpen }">
      <svg viewBox="0 0 24 24" width="24px" height="24px" focusable="false" aria-hidden="true"><path d="M7 10l5 5 5-5z"></path></svg>
    </div>
  }

  <!-- autocomplete -->
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange($event)">
    @for (option of filteredOptions | async; track option) {
      @if (selectionConfig.hasEmptyValue) {
        <mat-option></mat-option>
      }
      <mat-option [disabled]="setDisabled(option) || option.disabled" [value]="option.text">
        @if (selectionConfig.customOptionRenderer) {
          <ng-template *ngComponentOutlet="selectionConfig.customOptionRenderer; inputs: { option }" />
        } @else {
          {{ option.text | translate }}
        }
      </mat-option>
    }
    @if ((filteredOptions | async)?.length === 0) {
      <mat-option disabled="true">
        {{ 'no data found' | translate }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
